import posthog from "posthog-js"

const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY as string | undefined
const POSTHOG_HOST = (import.meta.env.VITE_POSTHOG_HOST as string | undefined) ?? "https://us.i.posthog.com"

/** Google Ads "Book appointment" conversion action. */
const ADS_BOOK_DEMO_CONVERSION = "AW-18338534998/EljjCJ651NMcENasv6hE"

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void
  }
}

/** Initialize PostHog. No-op when VITE_POSTHOG_KEY is unset (e.g. local dev). */
export function init_posthog() {
  if (!POSTHOG_KEY) return
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    // Opt into modern defaults: history-change pageview capture (SPA routing) etc.
    defaults: "2025-05-24",
  })
}

/** Capture a PostHog event. Safe to call when PostHog isn't configured. */
export function capture_event(event: string, properties?: Record<string, unknown>) {
  if (!POSTHOG_KEY) return
  posthog.capture(event, properties)
}

/**
 * Fire the Google Ads conversion + PostHog event for a "Book a demo" click.
 * Uses beacon transport so the ping survives same-tab navigation to Calendly.
 */
export function track_demo_click() {
  window.gtag?.("event", "conversion", {
    send_to: ADS_BOOK_DEMO_CONVERSION,
    value: 1.0,
    currency: "USD",
    transport_type: "beacon",
  })
  capture_event("book_demo_clicked")
}
